/* istanbul ignore file */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { ICaseDetail } from 'src/app/model/support/ICaseDetail';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  middlewareUrl: string;
  supportPath: string;
  clientName: string;

  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    public resourceService: ADPResourceService,
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.supportPath = this.preInitSettingsService.getSettings().middleWare.supportPath;
    this.clientName = this.resourceService.getPortalSetting("Chat_ClientName")?.Value
  }

  getCaseHistory(phoneNumber: string) {
    const httpOptions = {
      params: new HttpParams()
        .set('phoneNumber', phoneNumber)
        .set('clientName', this.clientName)
    };

    return this.http.get<ICaseDetail[]>(`${this.middlewareUrl}${this.supportPath}casedetails`, httpOptions);
  }

  getChatTranscripts(phoneNumber: string) {
    const httpOptions = {
      params: new HttpParams()
        .set('phoneNumber', phoneNumber)
        .set('clientName', this.clientName)
    };

    return this.http.get<any[]>(`${this.middlewareUrl}${this.supportPath}chattranscripts`, httpOptions);
  }
}
